import Grid from "@mui/material/Grid";
import React from "react";
import { useQueryClient } from "react-query";
import {
  CUSTOMER_INFO,
  EXISTING_LOANREQUEST,
  LOAN_TEMPLATE_INFOS,
} from "../../config/cacheKey";
import {
  CustomerInfo,
  ExistingLoanRequest,
  LoanTemplateInfo,
} from "../../models/loan.model";

export default function ConfirmationCard(props: any) {
  const queryClient = useQueryClient();
  const customerInfos = queryClient.getQueryData<CustomerInfo>(CUSTOMER_INFO);
  const existingLoanRequest = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST,
  );
  const loanInfo = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS,
  );

  const existingLoanInfo = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST,
  );
  let finalLoanAmount: any;
  if (existingLoanInfo === null) {
    finalLoanAmount = null;
  } else {
    finalLoanAmount = existingLoanInfo?.finalLoanAmount.toLocaleString();
  }

  const loanTemplateInfos = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS,
  );

  const finalInstallmentCount = existingLoanRequest?.finalInstallmentCount;
  const finalStepSpaceByMonth = existingLoanRequest?.finalStepSpaceByMonth;

  const listloan = loanInfo
    ?.filter((item: any) => item.id == existingLoanRequest?.loanTemplateId)
    .map((item: any, index: number, array: any) => {
      return {
        title: item.title,
        cardImage: item.cardImage,
        id: item.id,
        maxAmount: item.maxAmount,
        profitPercentage: item.profitPercentage,
        expirationDate_Persian: item.expirationDate_Persian,
      };
    });
  console.log("sfjhsdkjfhsdkjfhskdjh", props);
  return (
    <div>
      {/* <div className="row"> */}
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        className="row"
      >
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "4vh",
            paddingBottom: "0.1vh",
          }}
        >
          {/* <div
          className="col-2 col-md-2 col-lg-4  confirm"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        > */}
          <div className="colorTitle textFont16">
            <b>اطلاعات متقاضی:</b>
          </div>
          <div className="textFont14">
            <div>
              <span style={{ color: "#9AAFC4" }}>نام و نام خانوادگی:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.customerFullName}
              </span>
            </div>
            {props.value.digitallSignRequired ? (
              <div>
                <span style={{ color: "#9AAFC4" }}>نام انگلیسی:</span>
                <span style={{ color: "#34495E" }}>
                  {" "}
                  {props.value.englishFirstName} {props.value.englishLastName}
                </span>
              </div>
            ) : null}
            <div>
              <span style={{ color: "#9AAFC4" }}>کد ملی:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.customerNationalCode}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>تاریخ تولد:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.birthDatePersian}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>تلفن همراه:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.customerMobileNumber}
              </span>
            </div>
            {/* <div>
              <span style={{ color: "#9AAFC4" }}>شماره پرونده:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {customerInfos?.cellPhone}
              </span>
            </div> */}
          </div>
          {/* </div> */}
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          className="divisionConfirmationCardCmpFirst"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "4vh",
            paddingBottom: "0.1vh",
          }}
        >
          {/* <div
          className=" divisionConfirmationCardCmpFirst col-2  col-md-2 col-lg-4 confirm"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        > */}
          <div className="colorTitle textFont16">
            {/* {props.title2} */}
            <b>اطلاعات طرح تسهیلات:</b>
          </div>
          <div className="textFont14">
            <div>
              <span style={{ color: "#9AAFC4" }}>تامین کننده مالی: </span>
              <span style={{ color: "#34495E" }}>{props.value?.bankTitle}</span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>عنوان طرح: </span>
              <span style={{ color: "#34495E" }}>
                {props.value.loanTemplateTitle} <br />
                {props.value.isBySupplierCredit ? (
                  <b
                    style={{
                      textAlign: "right",
                      color: "#EE9D01",
                      fontSize: "10px",
                    }}
                  >
                    &nbsp; &nbsp;(تضمین از محل اعتبار تامین کننده
                    &nbsp;&nbsp;|&nbsp;&nbsp;اعتبار باقیمانده:{" "}
                    {props.value.supplierCredit.toLocaleString()}
                    &nbsp;&nbsp;ریال)
                  </b>
                ) : (
                  ""
                )}
              </span>
            </div>
            {props.value?.organizationTitle && (
              <div>
                <span style={{ color: "#9AAFC4" }}>سازمان: </span>
                <span style={{ color: "#34495E" }}>
                  {props.value?.organizationTitle}
                </span>
              </div>
            )}

            <div>
              <span style={{ color: "#9AAFC4" }}> سود تسهیلات:</span>{" "}
              <span style={{ color: "#34495E" }}>
                {props.value.profitPercentage} %
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}> نوع بازپرداخت:</span>{" "}
              <span style={{ color: "#34495E" }}>
                {props.value.repaymentTypeTitle}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>
                {" "}
                نوع پرداخت هزینه اشتراک:
              </span>{" "}
              <span style={{ color: "#34495E" }}>
                {props.value.feePaymentTypeTitle}
              </span>
            </div>
            {/* disable expaire date */}

            {/* {props.value.installmentAmount ? (
              <div>
                <b style={{ color: "#9AAFC4" }}> مبلغ قسط:&nbsp;</b>{" "}
                <b
                  style={{
                    color: "#fff",
                    background: "green",
                    borderRadius: "5px",
                    padding: "1px 3px",
                  }}
                >
                  {props.value.installmentAmount.toLocaleString()} ریال
                </b>
              </div>
            ) : null} */}
            {/* </div> */}
          </div>
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          className="divisionConfirmationCardCmpFirst"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "4vh",
            paddingBottom: "0.1vh",
          }}
        >
          {/* <div
          className="divisionConfirmationCardCmp col-2  col-md-2 col-lg-4 confirm"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        > */}
          <div className="colorTitle textFont16">
            {/* {props.title2} */}
            <b>اطلاعات درخواست:</b>
          </div>
          <div className="textFont14">
            <div>
              <span style={{ color: "#9AAFC4" }}>وضعیت درخواست: </span>
              <span style={{ color: "#34495E" }}>
                {props.value.loanRequestStatusTitle}
              </span>
            </div>

            <div>
              <span style={{ color: "#9AAFC4" }}>مبلغ تسهیلات:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.finalLoanAmount
                  ? props.value.finalLoanAmount.toLocaleString()
                  : ""}{" "}
                ریال
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>اعتبار مشتری :</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.creditAmount
                  ? props.value.creditAmount.toLocaleString()
                  : 0}{" "}
                ریال
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>هزینه اشتراک :</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.customerFeeAmount
                  ? props.value.customerFeeAmount.toLocaleString()
                  : 0}{" "}
                ریال
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>تاریخ ثبت درخواست: </span>
              <span style={{ color: "#34495E" }}>
                {props.value.requestDatePersian}
              </span>
            </div>
            {props.value.bankApproveDatePersian && (
              <div>
                <span style={{ color: "#9AAFC4" }}>تاریخ اعطا: </span>
                <span style={{ color: "#34495E" }}>
                  {props.value.bankApproveDatePersian}
                </span>
              </div>
            )}
            <div>
              <span style={{ color: "#9AAFC4" }}> دوره بازپرداخت:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.installmentDuration}
                &nbsp;ماه &nbsp;
              </span>
              <span style={{ color: "#9AAFC4" }}>با فاصله</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.stepSpace}
                &nbsp;ماه &nbsp;
              </span>
            </div>
            {/* {props.value.bankReferenceCode && (
              <div>
                <span style={{ color: "#9AAFC4" }}>شناسه تسهیلات: </span>
                <span style={{ color: "#34495E" }}>
                  {props.value.bankReferenceCode}
                </span>
              </div>
            )} */}

            {/* {props.value.supplierSettlementStatusTitle && (
              <div>
                <span style={{ color: "#9AAFC4" }}> وضعیت تسویه:</span>
                <span style={{ color: "#34495E" }}>
                  {" "}
                  {props.value.supplierSettlementStatusTitle}
                </span>
              </div>
            )} */}
            {/* {props.value.financialSupplierTitle && (
              <div>
                <span style={{ color: "#9AAFC4" }}>تامین کننده مالی:</span>
                <span style={{ color: "#34495E" }}>
                  {" "}
                  {props.value.financialSupplierTitle}
                </span>
              </div>
            )} */}

            {/* {props.value.title ? (
              <div>
                <span style={{ color: "#9AAFC4" }}> نام پذیرنده:</span>{" "}
                <span style={{ color: "#34495E" }}>{props.value.title}</span>
              </div>
            ) : null} */}
          </div>
          {/* {props.buttonChild} */}
        </Grid>
        {/* </div> */}
      </Grid>
      {/* </div> */}
    </div>
  );
}
